import { currencyFormat } from 'core/constants/formats';
import numeral from 'numeral';

export const centsToCurrency = (cents: number, format = currencyFormat, floor = false): string => {
  const value = cents / 100;
  return numeral(floor ? Math.floor(value) : value).format(format);
};
